module.exports = __webpack_public_path__ + "static/img/toronto1.06368b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/toronto1.jpg
// module id = 141
// module chunks = 9